import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { DamageService } from '../../service/damage.service';
import { Damage, DamageAnalysis, DamagesGroupedByLocation, Roi, RoiAnalysis } from '../../model/damage.model';
import { VehicleLocationPipe } from '../../pipes/vehicle-location.pipe';
import { Router } from '@angular/router';
import { ReportService } from '../../service/report.service';
import { Report } from '../../model/report.model';
import { RoiService } from '../../service/roi.service';
import { flatten } from 'lodash/array';
import { TraceService } from '../../service/trace.service';
import { Subscription } from 'rxjs';
import { ParametersService } from '../../service/parameters.service';
import { SearchTagCheckbox, FinderData, SelectPossibleOption } from '../../model/search';
import { TchekService } from '../../service/tchek.service';
import 'parse';
const parse: typeof Parse = require('parse');
import { VehicleDamagePipe } from '../../pipes/vehicle-damage.pipe';
import { ThumbnailService } from '../../service/thumbnail.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Settings } from '../../model/settings.model';
import { SearchService } from '../../service/search.service';
import { ClassificationService } from '../../service/classification.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { Company } from '../../model/company';
import { ParseFunctionService } from '../../service/parsefunction.service';
import { Tchek } from '../../model/tchek';
import { Tchekb, SeverityVehicleParts, TchekImages, TchekType } from '../../model/tchekb.model';
import * as DamageModel from '../../model/damage.model';
import { Vehicle } from '../../model/vehicle.model';
import { ToastService } from '../../service/toast.service';
import { VehicleService } from '../../service/vehicle.service';
import { groupDetailListType } from 'aws-sdk/clients/iam';
import { TchekImage } from '../../model/image';
import { timeStamp } from 'console';

@Component({
  selector: 'app-damage-analysis',
  templateUrl: './damage-analysis.component.html',
  styleUrls: ['./damage-analysis.component.less']
})
export class DamageAnalysisComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tchekId: string;
  @Input() reportId: string;
  @Input() currentMode: string;
  @Input() currentImage: TchekImage;
  // Indicates to change the layout for the drawer in Animation
  @Input() inPlayer: boolean;
  @Output() damageSelected: EventEmitter<Damage>;
  @Output() damageDeleted: EventEmitter<Damage>;
  loading: boolean;
  damages: DamageAnalysis[];
  damagesFilter: DamageAnalysis[];
  damageGroups: DamagesGroupedByLocation[];
  report: Report;
  damageLocationOptions: SelectPossibleOption[];
  severityOptionSelect: SelectPossibleOption[];
  subscription: Subscription[];
  saveTimers: Array<NodeJS.Timer>;
  canEdit = false;
  canDetection = false;
  damageActiveFilter: boolean = false;
  isSuperAdmin = false;
  selectedDamage: DamageAnalysis;
  selectedRoi: RoiAnalysis;
  traceByDamages = []
  activeRoiAdminDrawer = false;
  settings: Settings;
  settingsCompany: Settings;
  showParentDamage: boolean = true;
  company: Company
  classificationIsActive: boolean
  tchek: TchekImages
  activeSection: string;
  listHaveOldDamages: boolean = false;
  openLocations: string[] = []
  offsetScroll = 0;
  showTraces: boolean = false;
  currentUsername: string;
  timerEvent: NodeJS.Timer[] = [];
  comparisonIsActive: boolean = false
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (!this.isSuperAdmin)
      return


    if (event.key === 'o' || event.key === 'O')
      this.setAllOpen()

    if (this.tchek.inspectedByAlto) {
      if (event.key === '1') {
        if (!this.selectedDamage) {
          this._toastService.toastOpen(undefined, 'Select damage.', 'error')
          return
        }
        this.selectedDamage.isDeleted = false;
        this.selectedDamage.ignoreIt = false;
        this.selectedDamage.inspected = true;
        this.selectedDamage.getParseInstance().save();
        console.log("TRUE DAMAGE", this.selectedDamage.id)
        this.classificationDamageTchekAPI()
      }

      if (event.key === '2') {
        if (!this.selectedDamage) {
          this._toastService.toastOpen(undefined, 'Select damage.', 'error')
          return
        }
        this.selectedDamage.isDeleted = false;
        this.selectedDamage.ignoreIt = true;
        this.selectedDamage.inspected = false;
        this.selectedDamage.getParseInstance().save();
        console.log("IGNORE DAMAGE", this.selectedDamage.id)
        this.classificationDamageTchekAPI()
      }
      if (event.key === '3') {
        if (!this.selectedDamage) {
          this._toastService.toastOpen(undefined, 'Select damage.', 'error')
          return
        }
        this.selectedDamage.isDeleted = true;
        this.selectedDamage.ignoreIt = false;
        this.selectedDamage.inspected = false;
        this.selectedDamage.getParseInstance().save();
        console.log("FALSE DAMAGE", this.selectedDamage.id)
        this.classificationDamageTchekAPI()
      }
    }

  }

  constructor(
    private readonly _classificationService: ClassificationService,
    readonly _damageService: DamageService,
    private readonly _reportService: ReportService,
    private readonly _thumbnailService: ThumbnailService,
    private readonly _parseFunctionService: ParseFunctionService,
    private readonly _parametersService: ParametersService,
    private readonly _damageLocationPipe: VehicleLocationPipe,
    readonly _roiService: RoiService,
    private _traceService: TraceService,
    private readonly _router: Router,
    private readonly _toastService: ToastService,
    private readonly _vehicleService: VehicleService,
    private readonly _tchekService: TchekService,
    private readonly i18n: I18n,
  ) {
    this.currentUsername = parse.User.current().getUsername()
    this.canDetection = this._parametersService.canDetection;
    this.classificationIsActive = this._classificationService.active
    this.selectedDamage = this._classificationService.damageSelected
    this.selectedRoi = this._classificationService.roiSelected

    console.log('selected : ', this.selectedDamage, this.selectedRoi);
    this.canEdit = this._parametersService.canEdit;
    this.settings = this._parametersService.getAll()
    this.settingsCompany = this._parametersService.getAll(true)
    this.saveTimers = [];
    this.isSuperAdmin = this._parametersService.isSuperAdmin
    this.severityOptionSelect = this._roiService.severityOptionSelect
    this.loading = true;
    this.damages = [];
    this.damagesFilter = this.damages;
    this.inPlayer = false;
    this.damageSelected = new EventEmitter<Damage>();
    this.damageDeleted = new EventEmitter<Damage>();
    this.damageLocationOptions = flatten(Object.entries(this._roiService.parts)
      .map<SelectPossibleOption[]>(p => {
        return this._roiService
          .getAllLocationPossibleVariants(p[0], p[1])
          .map<SelectPossibleOption>(l => ({
            key: l,
            value: this._damageLocationPipe.transform(l)
          }));
      }));

    this.damageLocationOptions.sort((a, b) => {
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    });

    this.subscription = []
    this.subscription[0] = _damageService.createroiObs.subscribe(data => {
      if (this.tchekId === data.tchekId) {
        this.loading = true;
        this.onNewTchekId(data.tchekId);
        if (this.inPlayer)
          this._reportService.getByTchek(data.tchekId)
            .then(report => {
              this.loading = false;
              if (report.length < 1)
                return console.warn('Entered Player without a Report available for Tchek', data.tchekId);
              this.report = report[0];
            });
      }
    })

    this.subscription[1] = _parametersService.editDamageFilterObs.subscribe(() => {
      this.damageGroups = []
      this.loading = true;
      this.onNewTchekId(this.tchekId);
    })

    this.subscription[2] = this._classificationService.selectedDamageObs
      .subscribe(damageSelected => {
        console.log('damage subscriber da ');
        this.damageGroups.forEach(group => {
          group.damages.forEach(damage => {
            if (damage.id === damageSelected.id && damage !== this.selectedDamage) {
              this.handleRedirectToDamage(damage);
            }
          });
        });
      })

    this.subscription[3] = this._classificationService.createAnnotationObs
      .subscribe((damage: DamageAnalysis) => {
        if (damage && damage.listRoi && damage.listRoi.length < 1)
          this.damages = this.damages.filter(damageL => damageL.id !== damage.id);
        else
          this.damages[this.damages.findIndex(d => { return d.id === damage.id })] = damage
        if (this.damages[0] && this.damages[0].listRoi[0])
          this.handleRedirectToDamage(this.damages[0], this.damages[0].listRoi[0])
        this.damagesFilter = this.damagesFilter.filter(damage => {
          if (damage.listRoi.length > 0
            && damage.classification !== true
            && damage.skipClassification !== true
            && damage.isAuto === true
            && damage.listRoi.length > 0
          ) return true
          else return false
        })
        this.regroupDamages()
      })

    this.subscription[4] = this._tchekService.subscribeTcheks()
      .changedObservable.subscribe((tchek: Tchekb) => {

        if (this.classificationIsActive) return
        if (this.tchek && this.tchek.id !== tchek.id) return;
        console.log("subscribe tchek da");
        if (this.saveTimers[tchek.id]) {
          clearTimeout(this.saveTimers[tchek.id]);
          this.saveTimers[tchek.id] = undefined;
        }
        this.saveTimers[tchek.id] = setTimeout(async () => {
          console.log("subscribe tchek da TIMER");

          console.log('change class subscribe');
          let roiList = [];
          await (await this._roiService.getTchekRois(this.tchekId, true)).forEach(roi => {
            if (roi.get('damagePtr'))
              roiList.push(new DamageModel.Roi(roi))
          });
          roiList = await Promise.all(roiList.map<Promise<RoiAnalysis>>(d => {
            return this._roiService.toRoiAnalysisObject(d);
          }))
           this._damageService.reloadDamages = true
          this.damages = await Promise.all(
            (await this._damageService.getByTchek(this.tchek.id))
              .map<Promise<DamageAnalysis>>(d => {
                return this._damageService.toDamageAnalysisObject(d, roiList);
              })
          );
          console.log(this.damages);

          this.showParentDamage = this.report ? (this.report.oldDamages !== undefined ?
            this.report.oldDamages : (this.settingsCompany.report.oldDamages !== undefined ? this.settingsCompany.report.oldDamages : true))
            : (this.settingsCompany.report.oldDamages !== undefined ? this.settingsCompany.report.oldDamages : true);

          if (this.isSuperAdmin)
            try {
              this.traceByDamages = await this._traceService.getByDamages(this.damages);
            } catch (e) {
              console.error('Error on get trace', e);
            }
          this._thumbnailService.numberOfDamage = this.damages.length;
          if (this.inPlayer === false) {
            /// generate overlay base 64 here
            for await (let damage of this.damages) {
              damage.imageOverlay = await this._thumbnailService.generateOverlay(damage)
            }
          }
          this.damagesFilter = this.damages;

          this.regroupDamages()
          this.saveTimers[tchek.id] = undefined;
        }, 3000);


      })

    this.subscription[5] = this._damageService.comparisonObs.subscribe((active: boolean) => {
      this.showParentDamage = !active
      this.comparisonIsActive = active
      console.log('comparison : ', this.showParentDamage);
    })
  }

  ngOnInit() {
    $(window).resize(() => {
      this.changeAnimationSizeContainer()
    });
  }

  changeSource(event, roi: RoiAnalysis, roiImageList) {
    // event.target.src = '../../../assets/icon/corrupted@3x.png'
    // roiImageList.classList.add('active');
    // roiImageList.classList.remove('d-none');
    var image = new Image();
    image.src = roi.bestImageUrl.hd;
    image.crossOrigin = "Anonymous";
    image.onload = function () {
      event.target.src = roi.bestImageUrl.hd
      image.crossOrigin = "Anonymous";
      roiImageList.classList.add('active');
      roiImageList.classList.remove('d-none');
    }
    image.onerror = function () {
      event.target.src = '../../../assets/icon/corrupted@3x.png'
      roiImageList.classList.add('active');
      roiImageList.classList.remove('d-none');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tchekId && changes.tchekId.currentValue) {

      if (changes.tchekId.currentValue !== undefined) {
        console.log('load existing data', this._damageService.tchekId, changes.tchekId.currentValue);
        if (this._damageService.tchekId === undefined || this._damageService.tchekId === changes.tchekId.currentValue) {
          this.openLocations = this._damageService.openLocations
          this.offsetScroll = this._damageService.offsetScroll.valueOf()
          $("#scrollbox-damage").animate({ scrollTop: (this.offsetScroll) }, '0');
        } else {
          this.openLocations = []
          this.offsetScroll = 0
        }
        this._damageService.tchekId = changes.tchekId.currentValue
      }

      this.onNewTchekId(changes.tchekId.currentValue);
      if (this.inPlayer)
        this._reportService.getByTchek(changes.tchekId.currentValue)
          .then(report => {
            if (report.length < 1)
              return console.warn('Entered Player without a Report available for Tchek',
                changes.tchekId.currentValue);
            this.report = report[0];
          });
    }
    if (changes.reportId && changes.reportId.currentValue)
      this._reportService.get(changes.reportId.currentValue)
        .then(report => this.report = report);
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.subscription.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  private async onNewTchekId(id: string) {
    this._tchekService.getDA(this.tchekId, true).then(tchek => {
      this.tchek = tchek as TchekImages;

      if (this.tchek.inspectedByAlto) this._damageService.allOpenLocations = true

      if (tchek.getParseInstance().get('reportPtr') === undefined)
        this._reportService.getByTchek(id)
          .then(reports => {
            if (reports.length < 1)
              this._reportService.create(id)
                .then(report => {
                  this.report = report
                });
          })

		  if (this.tchek.type !== 4 || this.isSuperAdmin)
      this.company = this._parseFunctionService.getCompany(tchek.devicePtr.companyPtr, true)
      if (this.inPlayer && !this.isSuperAdmin) {
        if (tchek.playerOpen)
          tchek.playerOpen++;
        else
          tchek.playerOpen = 0;
      } else if (!this.isSuperAdmin) {
        if (tchek.reportOpen)
          tchek.reportOpen++;
        else
          tchek.reportOpen = 0;
      }
      this._tchekService.save(tchek)
    })
    try {
      let roiList = [];
      await (await this._roiService.getTchekRois(this.tchekId, true)).forEach(roi => {
        if (roi.get('damagePtr'))
          roiList.push(new DamageModel.Roi(roi))
      });
      roiList = await Promise.all(roiList.map<Promise<RoiAnalysis>>(d => {
        return this._roiService.toRoiAnalysisObject(d);
      }))
 
      this.damages = await Promise.all(
        (await this._damageService.getByTchek(id))
          .map<Promise<DamageAnalysis>>(d => {
            return this._damageService.toDamageAnalysisObject(d, roiList);
          })
      );
      //      console.log(this.damages);

      this.showParentDamage = this.report ? (this.report.oldDamages !== undefined ?
        this.report.oldDamages : (this.settingsCompany.report.oldDamages !== undefined ? this.settingsCompany.report.oldDamages : true))
        : (this.settingsCompany.report.oldDamages !== undefined ? this.settingsCompany.report.oldDamages : true);

      if (this.isSuperAdmin)
        try {
          this.traceByDamages = await this._traceService.getByDamages(this.damages);
        } catch (e) {
          console.error('Error on get trace', e);
        }
      this._thumbnailService.numberOfDamage = this.damages.length;
      if (this.inPlayer === false) {
        /// generate overlay base 64 here
        for await (let damage of this.damages) {
          damage.imageOverlay = await this._thumbnailService.generateOverlay(damage)
        }
      }
      this.damagesFilter = this.damages;
      this.regroupDamages()
      this.loading = false;
      setTimeout(() => {
        this.changeAnimationSizeContainer()
      }, 100);
    } catch (e) {
      console.error('Could not retrieve damages', e);
    }
  }

  onDamageSectionChange(e: string) {
    this.activeSection = e;
  }

  saveOr() {
    if (this.tchek.vehiclePtr && this.tchek.vehiclePtr.or)
      this.tchek.vehiclePtr.or = this.tchek.vehiclePtr.or.toLocaleUpperCase();
    clearTimeout(this.timerEvent[1]);
    this.timerEvent[1] = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._vehicleService.saveVehicle(
        this.tchek.vehiclePtr.id,
        this.tchek.vehiclePtr.immat,
        this.tchek.vehiclePtr.brand,
        this.tchek.vehiclePtr.model,
        this.tchek.vehiclePtr.or,
        this.tchek.vehiclePtr.vin,
        this.tchek.vehiclePtr.class,
        this.tchekId)
        .then((savedVehicle: Vehicle) => {
          this.tchek.vehiclePtr = savedVehicle[0];
          this.onNewTchekId(this.tchekId);
          this._toastService.toastOpen(false);
        });
    }, 500);
  }

  saveImmat(e) {
    clearTimeout(this.timerEvent[1]);
    this.timerEvent[1] = setTimeout(() => {
      this._toastService.toastOpen(true);
      this._vehicleService.saveVehicle(
        this.tchek.vehiclePtr.id,
        e.toLocaleUpperCase(),
        this.tchek.vehiclePtr.brand,
        this.tchek.vehiclePtr.model,
        this.tchek.vehiclePtr.or,
        this.tchek.vehiclePtr.vin,
        this.tchek.vehiclePtr.class,
        this.tchekId)
        .then((savedVehicle: Vehicle) => {
          this.tchek.vehiclePtr = savedVehicle[0];
          this.onNewTchekId(this.tchekId);
          this._toastService.toastOpen(false);
        });
    }, 500);
  }


  handleSetKpi(event: Event, tchek: Tchekb, active: boolean) {
    if (tchek.status === 5)
      tchek.status = 2;
    tchek.toSync = true;
    tchek.kpi = active;
    this.markDirty(tchek, { isNew: false });
    this.stopPropagation(event);
  }

  handleSetAsUnInspected(event: Event, tchek: Tchekb) {
    if (tchek.status === 5)
      tchek.status = 2;
    tchek.toSync = true;
    tchek.inspected = false;
    this.markDirty(tchek, { isNew: false });
    this.stopPropagation(event);
  }

  handleSetAsInspected(event: Event, tchek: Tchekb) {
    tchek.status = 5;
    tchek.inspected = true;
    tchek.isNew = false;
    tchek.toSync = true;
    this.markDirty(tchek, { isNew: true });
    this.stopPropagation(event);
  }

  handleSetAsFlagged(event: Event, tchek: Tchekb) {
    tchek.status = 4;
    tchek.isNew = false;
    tchek.isFlagged = true;
    tchek.toSync = true;
    this.markDirty(tchek, { isFlagged: true });
    this.stopPropagation(event);
  }

  handleSetAsUnflagged(event: Event, tchek: Tchekb) {
    tchek.status = 3;
    tchek.toSync = true;
    tchek.isFlagged = false;
    this.markDirty(tchek, { isFlagged: false });
    this.stopPropagation(event);
  }

  markDirty(tchek: Tchekb, fallback: { [key: string]: any }) {
    if (this.saveTimers[tchek.id]) {
      clearTimeout(this.saveTimers[tchek.id]);
      this.saveTimers[tchek.id] = undefined;
    }
    this.saveTimers[tchek.id] = setTimeout(() => {
      this._tchekService.save(tchek).then(savedTchek => {
        if (savedTchek === undefined) {
          // Falling back to original value
          const [key, value] = Object.entries(fallback)[0];
          tchek[key] = value;
        }
      });
      this.saveTimers[tchek.id] = undefined;
    }, 1000);
  }



  handlerChangeClassName(event) {
    this._toastService.toastOpen(true);
    this._vehicleService.saveVehicle(
      this.tchek.vehiclePtr.id,
      this.tchek.vehiclePtr.immat,
      this.tchek.vehiclePtr.brand,
      this.tchek.vehiclePtr.model,
      this.tchek.vehiclePtr.or,
      this.tchek.vehiclePtr.vin,
      this.tchek.vehiclePtr.class,
      this.tchekId)
      .then((savedVehicle: Vehicle) => {
        this.tchek.vehiclePtr = savedVehicle[0];
        this.onNewTchekId(this.tchekId);
        this._toastService.toastOpen(false);
      });
  }

  setShowParentDamage() {
    this.showParentDamage = !this.showParentDamage
    this.report.oldDamages = this.showParentDamage
    if (this.comparisonIsActive !== true)
      this.saveDataReport()
  }

  saveDataReport() {
    this._toastService.toastOpen(true);
    clearTimeout(this.timerEvent[0]);
    this.timerEvent[0] = setTimeout(() => {
      this._reportService.save(this.report).then((saved: Report) => {
        this.report = saved;
        //console.log("save Report settings", this.report)
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  classificationDamageTchekAPI() {
    if (!this.selectedDamage) {
      this.selectedDamage = this.damageGroups[0].damages[0]
    }
    let damages = []
    this.damageGroups.forEach(g => { damages = damages.concat(g.damages) })
    let index = damages.findIndex(d => { return d.id === this.selectedDamage.id })
    if (index < damages.length)
      this.handleRedirectToDamage(damages[index + 1])

    let groupIndex = this.damageGroups.findIndex(g => {
      return g.damages.findIndex(d => { return d.id === damages[index + 1].id }) !== -1
    })

    let GroupOffsetNext = document.getElementById(this.damageGroups[groupIndex].svgLocation + '-t').offsetTop
    let dam = document.getElementById(damages[index + 1].id).getBoundingClientRect()
    let head = document.getElementById(this.damageGroups[groupIndex].svgLocation + '-h').getBoundingClientRect()
    let offsetNext = document.getElementById(damages[index + 1].id).offsetTop
    console.log('offset ', GroupOffsetNext, offsetNext, dam.height);
    $("#scrollbox-damage").animate({ scrollTop: GroupOffsetNext + offsetNext - dam.height - head.height }, '0');
  }

  modalpush(event, id?: string, type?: string) {
    this.stopPropagation(event)
    this._damageService.modalOpen({ type: type, id: id });
  }

  changeAnimationSizeContainer() {
    if (this.inPlayer) {
      var headerDamage = $("#header-damage").height();
      var footerValidate = $("#footer-validate").height()
      var totalHeight = $(window).height();
      $("#scrollbox-damage").height(totalHeight - headerDamage - footerValidate);
    } else {
      $("#scrollbox-damage").css({ "maxHeight": "55vh" });
    }
  }

  hideDamageHandler(newList: DamageAnalysis[]) {
    if (this.damagesFilter !== newList) {
      this.damagesFilter = newList;
      this.regroupDamages()
    }
  }

  setOpenLocations(location: string) {
    if (this.openLocations.includes(location)) {
      this.openLocations.splice(this.openLocations.indexOf(location), 1)
    } else {
      this.openLocations.push(location)
    }
    this._damageService.openLocations = this.openLocations
  }

  damagesByGroup(damagesToGroup?: DamageAnalysis[]): DamagesGroupedByLocation[] {
    if (damagesToGroup === undefined)
      damagesToGroup = this.damages;
    let groupedDamages: DamagesGroupedByLocation[] = [];

    for (const damage of damagesToGroup) {
      const groupName = this._roiService.mapToSvgId(damage.location) // this._damageLocationPipe.returneLocation(damage.location);
      let index = groupedDamages.findIndex(data => { return data.location === groupName })
      if (index !== -1) {
        groupedDamages[index].damages.push(damage);
      } else {
        let severity: SeverityVehicleParts;

        let listIndexPart = [];
        if (this.tchek && this.tchek.severityVehicleParts) {
          listIndexPart = this.tchek.severityVehicleParts.reduce((array, sev, i) => {
            if (this._roiService.mapToSvgId(sev.location) === groupName)
              array.push(i);
            return array;
          }, [])
        }

        let data = { costType: 'sum', cost: 0, severity: 'SEV0', severityType: 'sum', location: groupName }
        severity = data
        if (listIndexPart.length > 0) {
          //listIndexPart sort : no manual after kittia
          listIndexPart.forEach(partIndex => {
            if (parseInt(severity.severity.slice(3, 4), 10) < parseInt(this.tchek.severityVehicleParts[partIndex].severity.slice(3, 4), 10))
              severity = this.tchek.severityVehicleParts[partIndex]
          });
        }

        groupedDamages.push({
          damages: [damage],
          severityPart: severity,
          newDamages: false,
          location: groupName,
          svgLocation: groupName
        })
      }
    }
    groupedDamages.forEach(group => {
      group.newDamages = !group.damages.every(damage => { return (damage.isParentDamage) })
    })
    //    console.log('groupdam', groupedDamages)
    this.listHaveOldDamages = !this.damagesFilter.every(damage => { return (!damage.isParentDamage) })
    return groupedDamages;

  }

  // * Call this function each time 'this.damages' is modified
  async regroupDamages() {
    let sortArray = this._damageService.getSortArray(this._parametersService.getAll().report.selectorSens)
    this.damageGroups = this.damagesByGroup(this.damagesFilter)
    this.damageGroups.sort((a, b) => {
      let i = sortArray.findIndex(array => (array === a.svgLocation))
      let j = sortArray.findIndex(array => (array === b.svgLocation))
      if (i === -1)
        i = sortArray.length + 1;
      if (j === -1)
        j = sortArray.length + 1;
      if (i === j && i === sortArray.length + 1)
        return (sortArray.length + 1)
      return (i - j);
    })
    this.damageGroups.forEach(e => { e.damages.sort((a, b) => { return (a.uid - b.uid); }) });
    let damageTmp: DamageAnalysis[];
    damageTmp = []
    this.damageGroups.forEach(list => {
      damageTmp = damageTmp.concat(list.damages)
    });
    this._classificationService.setDamageList(damageTmp)
    this.loading = false;
    this.changeAnimationSizeContainer()
    $("#scrollbox-damage").animate({ scrollTop: (this.offsetScroll) }, '0');

  }

  colorclick(damage: Damage, event) {
    if (this.canEdit === false)
      return;
    this.stopPropagation(event)
    let index = this.severityOptionSelect.findIndex(d => { return d.key === damage.severity });
    if ((index + 1) > 5)
      index = -1;
    if (!damage.severity)
      index = 0;
    if (this.saveTimers[damage.id]) {
      clearTimeout(this.saveTimers[damage.id]);
      this.saveTimers[damage.id] = undefined;
    }
    let oldDamageSeverity = damage.severity;
    damage.severity = this.severityOptionSelect[index + 1].key;

    damage.toSync = true;
    this.saveTimers[damage.id] = setTimeout(() => {
      this._traceService.saveTrace(
        damage.tchekPtr.id,
        `change damage severity {old : ${oldDamageSeverity}, new : ${damage.severity}}`,
        damage.id);
      this._damageService.save(damage)
      this.saveTimers[damage.id] = undefined;
    }, 1000);
  }

  colorclickGroup(group: DamagesGroupedByLocation, event) {
    if (this.canEdit === false)
      return;
    this.stopPropagation(event)

    let indexG = this.tchek.severityVehicleParts.findIndex(sev => {
      if (sev.location.startsWith('ROU'))
        return sev.location.replace('ROU', 'JNT') === group.location
      else
        return sev.location === group.location
    })
    let sevGroup = this.tchek.severityVehicleParts[indexG]

    let index = this.severityOptionSelect.findIndex(d => { return d.key === sevGroup.severity });
    if ((index + 1) > 5)
      index = -1;
    if (!sevGroup.severity || sevGroup.severity === '')
      index = 0;
    if (this.saveTimers[group.location]) {
      clearTimeout(this.saveTimers[group.location]);
      this.saveTimers[group.location] = undefined;
    }

    sevGroup.severity = this.severityOptionSelect[index + 1].key;
    sevGroup.severityType = 'manual'

    // Futur for severity 5

    this.tchek.toSync = true;
    this.saveTimers[group.location] = setTimeout(() => {
      this._tchekService.save(this.tchek)
      this.saveTimers[group.location] = undefined;
    }, 1000);
  }

  // Click on roi image star for change best Roi
  changeBestRoi(damage: Damage, roi: RoiAnalysis, event) {
    if (this.canEdit === false)
      return;
    this.stopPropagation(event)
    let oldRoi = damage.roiPtr.id.valueOf()
    damage.toSync = true;
    damage.roiPtr = roi
    this._traceService.saveTrace(
      damage.tchekPtr.id,
      `change damage bestroi {old : ${oldRoi}, new : ${damage.roiPtr.id}}`,
      damage.id);
    this._damageService.save(damage)
    this.saveTimers[damage.id] = undefined;
  }

  handleModal(data?: any) {
    if (data) {
      if (data.type === 'delete') {
        this.handleDamageDeletion(data.damage)
      }
      else if (data.type === 'create') {
        console.log('new damage ', data.damage);
        //this.onNewTchekId(this.tchekId)
      } else if (data.type === 'edit') {
        this.damages.filter(d => d.id === (data.damage as Damage).id)[0].listRoi = data.damage.listRoi
        this.damagesFilter = this.damages;
        //this.regroupDamages()
      }
    }
  }

  handleDamageDeletion(damage: Damage) {
    this._damageService.delete(damage).then(deletedDamage => {
      //console.log("DEBUG: handleDamageDeletion damage=",damage," => deletedDamage :",deletedDamage, (deletedDamage as Damage));
      if (this.isSuperAdmin !== true)
        this.damages = this.damages.filter(d => d.id !== (deletedDamage as Damage).id);

      this.damagesFilter = this.damages;
      this.loading = true;
      this.regroupDamages();
      if (this.inPlayer && this.isSuperAdmin !== true) {
        // Tell Canvas to delete also if in compact mode
        this._damageService.roiDeleted(damage)
        this.damageDeleted.emit(damage);
      }
      this.loading = false;
    });
  }

  handleDamageMouseEnter(event: Event, damage: Damage) {
    if (!this.inPlayer)
      return;
    const target = event.target as HTMLElement;
    target.classList.add('hovered-damage-row');
  }

  handleDamageMouseLeave(event: Event, damage: Damage) {
    if (!this.inPlayer)
      return;
    const target = event.target as HTMLElement;
    target.classList.remove('hovered-damage-row');
  }

  stopPropagation(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  async handleRedirectToDamage(damage: DamageAnalysis, roi?: RoiAnalysis, event?: Event) {
    //SBE 
    this.stopPropagation(event)
    this._damageService.offsetScroll = this.offsetScroll

    if (!this.inPlayer)
      return;

    if (this.selectedDamage && this.selectedDamage.id === damage.id && roi === undefined)
      this.selectedDamage = undefined;
    else
      this.selectedDamage = damage;


    this._classificationService.setSelectedDamage(this.selectedDamage)
    this.damageSelected.emit(this.selectedDamage);

    if (this.selectedDamage && !roi && this.classificationIsActive) {
      this.selectedRoi = this.selectedDamage.listRoi[0]
    } else if (this.selectedDamage && !roi) {
      let index = this.selectedDamage.listRoi.findIndex(roi => { return roi.id === this.selectedDamage.roiPtr.id })
      if (index >= 0)
        this.selectedRoi = this.selectedDamage.listRoi[index]
      else
        this.selectedRoi = this.selectedDamage.listRoi[0]
    } else if (this.selectedDamage && roi) {
      this.selectedRoi = roi;
    } else {
      this.selectedRoi = undefined;
    }
    this._roiService.setHighlightedRoi(this.selectedRoi)
    this._classificationService.setSelectedRoi(this.selectedRoi)

    if (this.selectedRoi) {
      console.log("handle damage", this.selectedRoi, damage)
      if (this.selectedRoi.imagePtr === undefined) {
        this._router.navigate([
          '/player',
          this.tchekId, this.selectedRoi.folderPtr.name,
          this.selectedRoi.folderPtr.toPercentage(this.selectedRoi.picture)
        ]);
        this._damageService.setSelectRoi({ image: this.selectedRoi.picture, folder: this.selectedRoi.folderPtr.name })
      } else {
        this._router.navigate([
          '/viewer',
          this.tchekId,
          this.selectedRoi.imagePtr.id
        ]);
        console.log('select damage : ', this.selectedRoi.imagePtr.id)
      }
    }

  }

  isCheckedDamage(damage: DamageAnalysis) {
    if (damage.checkedReport !== undefined) return damage.checkedReport
    else if (this._parametersService.getAll(true)
      && this._parametersService.getAll(true).report
      && this._parametersService.getAll(true).report.checkDamages !== undefined)
      return this._parametersService.getAll(true).report.checkDamages.valueOf()
    else return true
  }

  handleDamageToggleCheckbox(event: Event, damage: DamageAnalysis) {
    if (this.canEdit === false)
      return;
    damage.toSync = true;
    damage.checkedReport = !damage.checkedReport
    this.stopPropagation(event)
    if (this.saveTimers[damage.id]) {
      clearTimeout(this.saveTimers[damage.id]);
      this.saveTimers[damage.id] = undefined;
    }
    this.saveTimers[damage.id] = setTimeout(() => {
      this._toastService.toastOpen(true)
      this._damageService.save(damage).then(() => {
        this._toastService.toastOpen(false)
      })
      this.saveTimers[damage.id] = undefined;
    }, 1000);
  }

  setAllOpen() {
    this._damageService.allOpenLocations = !this._damageService.allOpenLocations
    console.log('set all open', this._damageService.allOpenLocations);
  }

  isDamageSelected({ id }: DamageAnalysis): boolean {
    if (!this.report || !this.report.selectedDamages)
      return false;
    return this.report.selectedDamages.includes(id);
  }

  filterItemsOfType(damageId) {
    return this.traceByDamages.filter(x => x.get("damagePtr").id == damageId);
  }

  hasDamageInPart(partId: string) {
    if (this.damages)
      return this.damages.find(d => {
        const normalizedPart = this._roiService.mapToSvgId(d.location);

        // console.log(normalizedPart, partId);
        if (!normalizedPart)
          return false;
        else if (normalizedPart === partId)
          return true;
      });
    else
      return false;
  }

  elementOffset(e) {
    this.offsetScroll = $('div.scrollbox').scrollTop();
    //    console.log(e);
  }


}



// WEBPACK FOOTER //
// ./src/app/element/damage-analysis/damage-analysis.component.ts